import { render, staticRenderFns } from "./push-manager-dialog.vue?vue&type=template&id=0843b046"
import script from "./push-manager-dialog.vue?vue&type=script&lang=js"
export * from "./push-manager-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports